(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    function openMoxMenuGuide() {
    const trigger = document.querySelector('[data-mog-open]');
    if (!trigger) return false;
    const openDrawer = document.querySelector('header-drawer details[open]');
    if (openDrawer) openDrawer.querySelector('.menu-drawer__close-button')?.click();
    trigger.click();
    return true;
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const guide = event.target.closest('[data-mox-menu-guide]');
    if (!guide || !document.querySelector('[data-mog-open]')) return;
    event.preventDefault();
    openMoxMenuGuide();
  });
  if (location.hash === '#mox-order-guide') openMoxMenuGuide();
  } catch(e) { console.error(e); }
})();

})();
